module.exports = __webpack_public_path__ + "img/m_home_head.89dda455.png";